import PropTypes from 'prop-types'
import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'
import Isvg from 'react-inlinesvg'

import ClickOutside from 'decorators/click_outside/click_outside_decorator'
import itemTypes from 'helpers/enums/dropdownIcon/itemTypes'
import dropdownIconThemeTypes from 'helpers/enums/dropdownIconThemeTypes'
import { Tooltip } from 'components/tooltip'

import styles from './dropdownIcon.scss'

import BetaLabel from 'assets/images/beta-label.svg'

class DropdownIcon extends Component {

	constructor() {
		super()

		this.state = {
			keyString: '',
			highlightedElement: -1,
		}
		this.keyTimeout = 0
		this.setRefElement = this.setRefElement.bind(this)
		this.doKeyUp = this.doKeyUp.bind(this)
		this.doKeyDown = this.doKeyDown.bind(this)
		this.doBlur = this.doBlur.bind(this)
	}

	componentDidMount() {
		this.elementList.focus()
	}

	componentWillUpdate(nextProps, nextState) {
		if (nextState.keyString === this.state.keyString || nextState.keyString === '') {
			return
		}
		const option = this.props.options.find(option => {
			const optionText = option[this.props.text_key]
			if (optionText.toLowerCase().indexOf(nextState.keyString.toLowerCase()) === 0) {
				return true
			}
		})
		if (option) {
			this.setIndexAndScroll(this.props.options.indexOf(option))
		}
	}

	componentWillUnmount() {
		clearTimeout(this.keyTimeout)
	}

	doBlur() {
		if (this.props.onBlur) {
			this.props.onBlur()
		}
	}

	resetKeyString() {
		this.setState({
			keyString: '',
		})
	}

	onMouseOver(option) {
		const index = this.props.options.indexOf(option)
		this.setState({highlightedElement: index})
	}

	setIndexAndScroll(index) {
		this.elementList.scrollTop = index * 40
	}

	doKeyUp(ev) {
		if (ev.keyCode >= 65 && ev.keyCode <= 90 || ev.keyCode !== 32) {
			ev.preventDefault()
			ev.stopPropagation()
			this.setState({
				keyString: this.state.keyString + ev.key,
			})
			clearTimeout(this.keyTimeout)
			this.keyTimeout = setTimeout(this.resetKeyString.bind(this), 1000)
		}
		if (ev.keyCode === 13 && this.state.highlightedElement >= 0) {
			this.props.onElementClick(this.props.options[this.state.highlightedElement])
		} else if (ev.keyCode === 38 && this.state.highlightedElement > 0) {
			this.setIndexAndScroll(this.state.highlightedElement)
		} else if (ev.keyCode === 40 && this.state.highlightedElement < this.props.options.length - 1) {
			this.setIndexAndScroll(this.state.highlightedElement)
		}
	}

	doKeyDown(ev) {
		if (ev.keyCode === 38 && this.state.highlightedElement > 0) {
			this.setState({highlightedElement: this.state.highlightedElement - 1})
			this.setIndexAndScroll(this.state.highlightedElement)
		} else if (ev.keyCode === 40 && this.state.highlightedElement < this.props.options.length - 1) {
			this.setState({highlightedElement: this.state.highlightedElement + 1})
			this.setIndexAndScroll(this.state.highlightedElement)
		}
	}

	setRefElement(element) {
		this.elementList = element
	}

	getTheme = () => {
		if (Object.keys(dropdownIconThemeTypes).find(key => dropdownIconThemeTypes[key] === this.props.theme)) {
			return {
				[`item--${this.props.theme}`]: true,
			}
		}
		return null
	}

	buildButtonItem = (option, index) => (
		<li
			key={option[this.props.key_name]}
			styleName={classNames({
				item: true,
				'item--highlighted': index === this.state.highlightedElement,
				...this.getTheme(),
			})}
			onMouseOver={() => this.onMouseOver(option)}
			onClick={option.disabled ? null : () => this.props.onElementClick(option)}
		>
			{option.tooltip && option.disabled &&
				<div styleName='item-tooltip'>
					<Tooltip>
						{option.tooltip}
					</Tooltip>
				</div>
			}
			<div
				styleName={classNames({
					'item--disabled': option.disabled,
				})}
			>
				<div styleName='item-icon'>
					{option[this.props.icon]}
				</div>
				{ option[this.props.text_key] &&
					<label styleName='item-text'>
						{option[this.props.text_key]}
					</label>
				}
				{ option.component }
				{ option.beta &&
					<Isvg src={BetaLabel} cacheGetRequests={true} styleName='item-beta-label' />
				}
			</div>
		</li>
	)

	buildSeparatorItem = id => (
		<li styleName='separator' key={id}></li>
	)

	itemBuilders = {
		[itemTypes.BUTTON]: this.buildButtonItem,
		[itemTypes.SEPARATOR]: this.buildSeparatorItem,
	}

	render() {
		const ListElements = this.props.options.map((option, index) =>
			this.itemBuilders[option.type || itemTypes.BUTTON](option, index)
		)

		return (
			<ClickOutside
				clickOutsideHandler={this.props.clickOutsideHandler}>
				<ul
					tabIndex={this.props.tabIndex}
					ref={this.setRefElement}
					styleName={classNames({
						box: true,
						'box--double': this.props.size === 'double',
					})}
					onKeyUp={this.doKeyUp}
					onKeyDown={this.doKeyDown}
					onBlur={this.doBlur}
				>
					{ ListElements }
				</ul>
			</ClickOutside>
		)
	}
}

DropdownIcon.propTypes = {
	options: PropTypes.array,
	onElementClick: PropTypes.func,
	theme: PropTypes.oneOf(Object.values(dropdownIconThemeTypes)),
}

DropdownIcon.defaultProps = {
	key_name: 'value',
	text_key: 'text',
	icon: 'icon',
	theme: dropdownIconThemeTypes.BIG_ICONS,
}

export default CSSModules(DropdownIcon, styles, {allowMultiple: true})
